import Vue from 'vue'

export const makeMessageDataForFirebase = ({message}) => {
  return {
    employee_code: message.employee_code,
    chat_group_id: message.chat_group_id,
    display_name: message.display_name,
    content: message.content,
    has_attachment: message.has_attachment,
    attachment: message.attachment,
    attachment_url: message.attachment_url,
    favorite_display_names: '',
    created_at: message.created_at,
    updated_at: message.updated_at,
    deleted_at: message.deleted_at ? message.deleted_at : false,
    is_ng: message.is_ng,
    read_count: message.read_count
  }
}

export const makeChatGroupDataForFirebase = ({chatGroup, lastMessage}) => {
  return {
    company_code: chatGroup.company_code,
    market_code: chatGroup.market_code,
    institution_code: chatGroup.institution_code,
    last_message: lastMessage,
    last_timestamp: Date.now(),
    total: chatGroup.total_messages
  }
}

export const checkResponseStatus = (response) => {
  return response && response.status === 200
}

export const isCurrentEmployeeApprove = (finePlay) => {
  const employeeCode = Vue.auth.user().employee_code
  const myIndexOfHistory = finePlay.fine_play_histories.findIndex(n => n.recipient_employee_code === employeeCode)
  if (myIndexOfHistory > 0) {
    const statusOfPreEmployee = finePlay.fine_play_histories[myIndexOfHistory - 1].status
    const statusOfMyEmployee = finePlay.fine_play_histories[myIndexOfHistory].status
    if (statusOfPreEmployee === 'preapproval') {
      return false
    }
    if (statusOfMyEmployee !== 'preapproval') {
      return false
    }
  }
  return true
}



// WEBPACK FOOTER //
// ./src/helpers.js